import { cx } from '@linaria/atomic';
import { Actions, TimeBar, WeekDayBar } from './atoms';
import { WeekViewDatePickerProps } from './types';
import { WeekViewDatePickerProvider } from './week-view-date-picker.provider';
import { weekViewDatePickerBaseStyle, weekViewDatePickerThemeStyles } from './week-view-date-picker.styles';

export const WeekViewDatePicker = ({ children, className, theme = 'light', ...rest }: WeekViewDatePickerProps) => {
  return (
    <WeekViewDatePickerProvider {...rest}>
      <section className={cx(weekViewDatePickerBaseStyle, weekViewDatePickerThemeStyles[theme], className)}>
        <WeekDayBar {...rest} />
        {children}
      </section>
    </WeekViewDatePickerProvider>
  );
};

WeekViewDatePicker.Actions = Actions;
WeekViewDatePicker.TimeBar = TimeBar;
